type Callback = () => void;

export default function semaphore(capacity = 1) {
    let pending = 0;
    const takeListeners: Callback[] = [];
    const leaveListeners: Callback[] = [];

    return {
        take() {
            if (pending < capacity) {
                takeListeners.forEach((l) => l());
            }
            ++pending;
        },

        leave() {
            --pending;
            if (pending < capacity) {
                leaveListeners.forEach((l) => l());
            }
        },

        onTake(callback: () => void) {
            takeListeners.push(callback);
        },

        onLeave(callback: () => void) {
            leaveListeners.push(callback);
        },
    };
}
